module.exports = __webpack_public_path__ + "static/media/developmentlook.692c0955.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/developmentlook.png
// module id = 848
// module chunks = 7